import { QueryClient, useMutation, useQueryClient } from '@tanstack/react-query'
import {
  permitKeys,
  RequestTypes,
} from '@core/react-query/features/permits/permit'
import { IPermitBase } from '@core/entities/permit/PermitBase'
import { permitsKeys } from '@core/react-query/features/permits'
import { useMutateQueryData } from '@core/react-query/hooks'
import { RequestErrorType } from '@core/utils/api-axios-instance'

export const getUpdatePermitDraftMutationOptions = (
  queryClient?: QueryClient,
) => {
  const { updateInfiniteQueryItem } = useMutateQueryData(queryClient)
  return {
    ...permitKeys.updateDraft,
    onSuccess: (permit) => {
      updateInfiniteQueryItem(
        permitsKeys.drafts({
          organisationId: permit.template.organisationId,
          projectIds: [permit.projectId],
        }).queryKey,
        permit,
      )
    },
  }
}

/**
 * Updates an existing permit draft.
 *
 * IMPORTANT: [LEGACY CLEANUP - Must happen BEFORE API deprecation]
 * The underlying mutation uses deprecated fields (`body`, `authorisedPersonInitiateBody`)
 * to upload files, then puts results in the wrappers. If the API removes these deprecated
 * fields before we migrate to using only the wrapper fields, permit draft updates will break.
 *
 * Known limitation: This mutation always sends both permitHolderAnswersWrapper AND
 * authorisedPersonAnswersWrapper. This works because drafts only have answers for one
 * flow (the other is always empty). When legacy is removed, refactor to conditionally
 * handle flows like createDraft does.
 */
export const useUpdatePermitDraft = () => {
  const queryClient = useQueryClient()
  return useMutation<
    IPermitBase,
    RequestErrorType,
    RequestTypes['updateDraft']
  >(getUpdatePermitDraftMutationOptions(queryClient))
}
